<template>
  <router-link :to="{ name: 'single-plant', params: { slug: slug }}" class="nav__btn" :class="classes">
    <svg class="nav__arrow" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="54px" height="54px" @click="pushTheButton()"
    @mouseenter="onMouseEnter()"
    @touchstart="onMouseEnter()"
    @mouseleave="onMouseLeave()"
    @touchend="onMouseLeave()">
      <defs>
        <filter filterUnits="userSpaceOnUse" id="Filter_0" x="0px" y="0px" width="54px" height="54px"  >
            <feOffset in="SourceAlpha" dx="0" dy="0" />
            <feGaussianBlur result="blurOut" stdDeviation="3" />
            <feFlood flood-color="rgb(0, 0, 0)" result="floodOut" />
            <feComposite operator="atop" in="floodOut" in2="blurOut" />
            <feComponentTransfer><feFuncA type="linear" slope="0.26"/></feComponentTransfer>
            <feMerge>
            <feMergeNode/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <path class="circle-shadow" filter="url(#Filter_0)" fill-rule="evenodd"  fill="rgb(255, 255, 255)"
      d="M26.000,10.500 C34.837,10.500 42.000,17.663 42.000,26.500 C42.000,35.337 34.837,42.500 26.000,42.500 C17.163,42.500 10.000,35.337 10.000,26.500 C10.000,17.663 17.163,10.500 26.000,10.500 Z"/>
      <path class="circle" fill-rule="evenodd"  fill="rgb(255, 255, 255)"
      d="M26.000,10.500 C34.837,10.500 42.000,17.663 42.000,26.500 C42.000,35.337 34.837,42.500 26.000,42.500 C17.163,42.500 10.000,35.337 10.000,26.500 C10.000,17.663 17.163,10.500 26.000,10.500 Z"/>
      <g class="arrow" transform="translate(20,18)" v-if="direction == 'prev'">
        <path fill-rule="evenodd"  fill="rgb(197, 195, 176)" d="M7.895,16.192 L0.495,9.000 L7.895,1.808 C8.463,2.235 8.984,2.720 9.437,3.266 L3.537,9.000 L9.437,14.734 C8.984,15.280 8.463,15.765 7.895,16.192 Z"/>
      </g>

      <g class="arrow" transform="translate(21,18)" v-else>
        <path fill-rule="evenodd"  fill="rgb(197, 195, 176)" d="M3.605,1.808 L11.005,9.000 L3.605,16.192 C3.037,15.765 2.516,15.280 2.063,14.734 L7.963,9.000 L2.063,3.266 C2.516,2.720 3.037,2.235 3.605,1.808 Z"/>
      </g>
    </svg>
  </router-link>
</template>

<script>
import 'styles/components/navigation-button.styl'
import Emitter from 'core/Emitter'
import TweenMax from 'gsap'

export default {
  name: 'navigation-button',
  data () {
    return {
    }
  },
  props: [
    'slug',
    'direction'
  ],
  computed: {
    classes () {
      let c = {}
      c[`nav__btn--${this.direction}`] = true

      return c
    }

  },
  mounted () {
    this.addListeners()

    this.circleEl = this.$el.querySelector('.circle')
    this.arrowEl = this.$el.querySelector('.arrow')
  },
  beforeDestroy () {
    this.removeListeners()
  },
  methods: {
    addListeners () {
    },

    removeListeners () {
    },

    onMouseEnter () {
      this.focus = true
      this.tlEnter = new TimelineMax()
      this.tlEnter.to(this.circleEl, 0.5, {
        transformOrigin: '50% 50%',
        scale: 1.6,
        // transformOrigin: '50% 50%',
        ease: Back.easeOut
      }, 'start')
      .to(this.arrowEl, 0.4, {
        transformOrigin: '50% 50%',
        scale: 1.15,
        ease: Quint.easeOut
      }, 'start')
    },

    onMouseLeave () {
      this.focus = false
      this.tlPush && this.tlPush.isActive() && this.tlPush.kill()
      this.tlLeave = new TimelineMax()
      this.tlLeave.to(this.circleEl, 0.6, {
        transformOrigin: '50% 50%',
        scale: 1,
        ease: Quint.easeOut
      }, 'start')
      .to(this.arrowEl, 0.4, {
        transformOrigin: '50% 50%',
        scale: 1,
        ease: Quint.easeOut
      }, 'start')
    },

    pushTheButton () {
      let circleScale = this.focus ? 1.6 : 1
      let arrowScale = this.focus ? 1.15 : 1
      Emitter.emit('SOUND::PLAY_NAV_CLICK', {direction: this.direction})
      this.tlPush = new TimelineMax()
      this.tlPush.to(this.circleEl, 0.3, {
        transformOrigin: '50% 50%',
        scale: 1.3,
        ease: Sine.easeOut
      }, 'first')
      .to(this.circleEl, 0.4, {
        transformOrigin: '50% 50%',
        scale: circleScale,
        ease: Quint.easeOut
      }, 'second')
      .to(this.arrowEl, 0.4, {
        transformOrigin: '50% 50%',
        scale: 0.8,
        ease: Quint.easeOut
      }, 'first')
      .to(this.arrowEl, 0.4, {
        transformOrigin: '50% 50%',
        scale: arrowScale,
        ease: Quint.easeOut
      }, 'second')
    }

  }
}
</script>



/** WEBPACK FOOTER **
 ** NavigationButton.vue?64533970
 **/